import Vue from "vue";
import Router from "vue-router";
import AuthGuard from "./auth-guard";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      meta: { offlineAvailability: true, fullscreen: true },
      component: () =>
        import(/* webpackChunkName: "login" */ "../views/Login.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/",
      name: "dashboard",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/applications",
      name: "applications",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "applications" */ "../views/Applications.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/organizations",
      name: "organizations",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "organizations" */ "../views/Organizations.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/ownerships",
      name: "ownerships",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "ownerships" */ "../views/Ownerships.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/deployments",
      name: "deployments",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "deployments" */ "../views/Deployments.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/devices",
      name: "devices",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "devices" */ "../views/Devices.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/deviceTypes",
      name: "deviceTypes",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "deviceTypes" */ "../views/DeviceTypes.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/events",
      name: "events",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "events" */ "../views/Events.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/eventLogs",
      name: "eventLogs",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "eventLogs" */ "../views/EventsRaw.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/rock7",
      name: "rock7",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "rock7" */ "../views/Rock7.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/triggerEvents",
      name: "triggerEvents",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "triggerEvents" */ "../views/TriggerEvents.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/users",
      name: "users",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "users" */ "../views/Users.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/userProfile",
      name: "userProfile",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "userProfile" */ "../views/UserProfile.vue")
    },
    {
      beforeEnter: AuthGuard,
      path: "/documentation",
      name: "documentation",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "documentation" */ "../views/Documentation.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/deviceStatus",
      name: "deviceStatus",
      meta: { offlineAvailability: false },
      component: () =>
        import(
          /* webpackChunkName: "deviceStatus" */ "../views/DeviceStatus.vue"
        )
    },
    {
      beforeEnter: AuthGuard,
      path: "/map",
      name: "map",
      meta: { offlineAvailability: false },
      component: () =>
        import(/* webpackChunkName: "map" */ "../views/MapPrototype.vue")
    }
  ]
});
